module.exports = __webpack_public_path__ + "img/account-circle.beee9f88.svg";